var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative my-2 flex items-center justify-center"},[_c('img',{staticClass:"h-24 object-contain",attrs:{"src":_vm.getImage('star_heart.png')}})])}
var staticRenderFns = []

export { render, staticRenderFns }